module.exports = __webpack_public_path__ + "assets/9ba769532d58bac7849caba9cf324da7.png";